import React, { useState } from "react";
import { Modal, Flex, List, Button, Input, Popover, message } from "antd";
import EmojiPicker from "emoji-picker-react";
import EmojiIcon from "../../../assets/icons/Emoji";
import { CloseCircleOutlined } from "@ant-design/icons";
import { setCurrnetUserDetails, setLoading, setUpdateStatus } from "../../../store";
import ApiService from "../../../API/apiService";
import { API_ENDPOINTS } from "../../../API/endpoints";
import { handleApiError } from "../../../utils/CommonFunctions";

const CustomStatusModal = ({ userData, isSetCustomStatusModalOpen, changeCustomStatusModal,onUserDetailsUpdate }) => {
  const [customStatusValue, setCustomStatusValue] = useState("");
  const [emojiData, setEmojiData] = useState({ emoji: "" });
  const [isOpenEmoji, setIsOpenEmoji] = useState(false);

  const setCustomStatusListData = [
    {
      title: "In a meeting",
      icon: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c5.png",
    },
    {
      title: "Out for lunch",
      icon: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f354.png",
    },
    {
      title: "Out sick",
      icon: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f927.png",
    },
    {
      title: "Working from home",
      icon: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e1.png",
    },
    {
      title: "On a vacation",
      icon: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f334.png",
    },
  ];

  const handleSetCustomStatusModalClose = () => {
    changeCustomStatusModal(false);
    setCustomStatusValue("");
    setEmojiData({ emoji: "", imageUrl: "" });
    setIsOpenEmoji(false);
  };

  const handleEmojiClicked = (emojiChangeData) => {
    setEmojiData(emojiChangeData);
    setIsOpenEmoji(false);
  };

  const clearEmojiIcon = () => {
    setEmojiData({ emoji: "" });
    setCustomStatusValue("");
  };

  
const RenderEmojiContainer = () => {
    return <EmojiPicker onEmojiClick={ handleEmojiClicked } />;
  };

  const handleCustomStatus = async (clearStatus = false) => {

    

    let reqBody = {
      customStatus: customStatusValue,
      user_id: userData?._id,
      is_custom_status: true,
    };

    if (emojiData.imageUrl) {
      reqBody.customStatusEmoji = emojiData.imageUrl;
    }

    if (clearStatus) {
      reqBody.customStatusEmoji = "";
      reqBody.customStatus = "";
    }

    setLoading(true);
    try {
      const response = await ApiService.post(
              API_ENDPOINTS.updateUserDetails,
              reqBody
            );
    
      if (response?.data && response?.statusCode === 200) {
        // Update user details here if needed
        if (!clearStatus) {
          handleSetCustomStatusModalClose();
        }
        onUserDetailsUpdate(response.data)
        setUpdateStatus(true);
        if (!clearStatus) handleSetCustomStatusModalClose();
        setCustomStatusValue("");
        setEmojiData({ emoji: "", imageUrl: "" });
      } else {
        handleSetCustomStatusModalClose();
        setCustomStatusValue("");
        message.error(response.data.message);
        setEmojiData({ emoji: "" , imageUrl: "" });
      }
    } catch (error) {
      handleApiError(error, "Error while updating status");
      // apiServices.showMessageOnce("Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Set a status"
      open={isSetCustomStatusModalOpen}
      onCancel={handleSetCustomStatusModalClose}
      footer={
        <Button
          type="text"
          onClick={() => handleCustomStatus()}
          className="primary-btn"
          style={{ padding: "10px" }}
          disabled={customStatusValue.trim() === ""}
        >
          Set Status
        </Button>
      }
      className="ec-modal set-custom-status-modal"
      width={600}
      style={{ top: 90 }}
    >
      <Flex gap="small" className="ant-modal-subheader">
        <div className="search-container">
          <Popover
            trigger="click"
            arrow={false}
            placement="bottom"
            content={ RenderEmojiContainer() }
            open={isOpenEmoji}
            onOpenChange={(open) => setIsOpenEmoji(open)}
          >
            {emojiData.emoji ? (
              <img className="search-icon" width={20} height={20} src={emojiData.imageUrl} alt="emoji" />
            ) : (
              <i className="search-icon" >
                <EmojiIcon />
              </i>
            )}
          </Popover>
          <input
            type="text"
            className="custom-search"
            placeholder="Set a status"
            value={customStatusValue}
            onChange={(e) => {
              if (e.target.value.length <= 50) {
                setCustomStatusValue(e.target.value);
              }
            }}
          />
          {(Boolean(emojiData.emoji) || customStatusValue !== "") && (
            <Button className="search-clear" onClick={clearEmojiIcon}>
              <CloseCircleOutlined />
            </Button>
          )}
        </div>
      </Flex>
      <Flex vertical className="suggestion-list-container">
        {customStatusValue !== "" ? (
          <div style={{ display: "flex", width: "100%", justifyContent: "end", padding: "15px" }}></div>
        ) : (
          <List
            className="suggestion-list"
            itemLayout="horizontal"
            dataSource={setCustomStatusListData}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  onClick={() => {
                    setCustomStatusValue(item.title);
                    setEmojiData({ emoji: item.title, imageUrl: item.icon });
                  }}
                  title={
                    <Flex gap="small">
                      <img className="emoji" width={20} height={20} src={item.icon} alt={item.title} />
                      <span className="title">{item.title}</span>
                    </Flex>
                  }
                />
              </List.Item>
            )}
          />
        )}
      </Flex>
    </Modal>
  );
};

export default CustomStatusModal;
